import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForAutoGenerator } from "@/components/features/_model/types/auto-generator-for-view-model";
import { QuestionSectionWrapper } from "@/components/features/items/edit/_shared/ui/components/system/question/_layouts/item-wrapper";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

type Props = {
	longStayParams: ForAutoGenerator<
		| {
				minimumStayDates?: number | undefined;
		  }
		| null
		| undefined,
		""
	>;
	onSetLongStayParams: (input: number | undefined) => void;
};
export const QuestionPlanLongStayParams = ({ longStayParams, onSetLongStayParams }: Props) => {
	const label = "最短連泊期間";
	const guide = "このプランの連泊数に制限をかけることができます。<br />ここでは最低宿泊日数を設定できます。";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={label}
			guide={guide}
			isEdited={longStayParams?.minimumStayDates?.isEdited}
			hasError={Boolean(longStayParams?.minimumStayDates?.error)}
			inputChildren={
				<QuestionSectionWrapper>
					<InputNumberField
						value={longStayParams?.minimumStayDates?.value}
						handleInput={onSetLongStayParams}
						errorMessage={longStayParams?.minimumStayDates?.error}
						hiddenSpinButton={false}
					/>
					<p>
						泊 <strong className="underline decoration-2 underline-offset-2">から</strong> 宿泊可能
					</p>
				</QuestionSectionWrapper>
			}
		/>
	);
};

QuestionPlanLongStayParams.displayName = "QuestionPlanLongStayParams";
